$(document).ready(function() {
$('ul.site-nav li.site-nav--has-dropdown > a').removeAttr('href');
$('ul.site-nav li.site-nav--has-dropdown > a').attr('role', 'button');
$('.index-section.remove-spacing .h1').first().attr('aria-level', '1');
$('.index-section.remove-spacing .h1').first().attr('role', 'heading');
$('.rte.rte--nomargin h3').empty().remove();
$('br').attr('aria-hidden','true');
// $("a[href='https://www.shopify.com/pos?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore']").attr('aria-label','Pos and you will leaving ameandlulu.com to a booking system on www.shopify.com');
// $("a[href='https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore']").attr('aria-label','Ecommerce by Shopify and and you will leaving ameandlulu.com to a booking system on www.shopify.com');
$("a[href='mailto:sales@ameandlulu.com']").attr('aria-label','Email Address: sales@ameandlulu.com: This link will open in a new window.');
$("a[href='mailto:info@ameandlulu.com%20']").attr('aria-label','Email Address: info@ameandlulu.com: This link will open in a new window.');
$("a[href='tel:+6179161755']").attr('aria-label','Phone Number: 617-916-1755: This link will open in a new window.');
$('a').each(function () {
  // Check if the link is external
  if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'www.ameandlulu.com') {
    // Create a span element with warning text
    var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
    // Set attributes for accessibility
    $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
    // Append the warning span inside the link
    $(this).append(warningSpan);
  }
});
$("button.drawer__close-button").on("click", function () {
  setTimeout(function () {
    $("button.shopify-payment-button__button").attr("tabindex", 0).focus();
  }, 1000);
});
});
$(document).ready(function() {
    // Handle click events on elements with the class "site-nav--has-dropdown"
    $("li.site-nav--has-dropdown").click(function() {
      const $dropdown = $(this).find(".site-nav__link--has-dropdown"); // Only select the first occurrence
    
      if ($dropdown.attr("aria-expanded") === "false") {
        // Close other dropdowns first
        $("li.site-nav--has-dropdown > .site-nav__link--has-dropdown").attr("aria-expanded", "false");
        $("li.site-nav--has-dropdown").removeClass("active");
        
        // Open the clicked dropdown
        $dropdown.attr("aria-expanded", "true");
        $(this).addClass("active");
        
        // Add your code to display the dropdown menu as needed here
      } else {
        // Close the clicked dropdown
        $dropdown.attr("aria-expanded", "false");
        $(this).removeClass("active");
        
        // Add your code to hide the dropdown menu as needed here
      }
    });
    });
  
    // Handle focus events for VoiceOver
    $(document).on('focusin', function(event) {
      // Check if the focus is outside of elements with class "site-nav--has-dropdown"
      if ($(event.target).closest(".site-nav--has-dropdown").length === 0) {
        // Close all dropdowns by setting their "aria-expanded" attribute to "false"
        $("li.site-nav--has-dropdown > .site-nav__link--has-dropdown").attr("aria-expanded", "false");
        $("li.site-nav--has-dropdown").removeClass("active");
        
        // Add your code to hide the dropdown menu as needed here
      }
    });

    $(document).ready(function() {
      var $menu1 = $('li.site-nav__item.site-nav__expanded-item.site-nav--has-dropdown.site-nav--is-megamenu');
        var $menu2 = $('a.site-nav__link.site-nav__link--underline.site-nav__link--has-dropdown');    
      $(document).keydown(function(event) {
        if (event.key === 'Escape') {
          $menu1.removeClass('active');
          $menu2.attr('aria-expanded', 'false');
        }
      });
    });